<template>
  <div class="user-info">
    <div class="header">
      <div style="font-size: 56px;">
        <van-icon name="contact" />
      </div>
      <div class="info">
        <h2 class="name">{{ user.username }}</h2>
        <p class="gold">{{ user.points }} 金豆 <span class="exchange" @click="$router.push('/merchandise')">兑</span></p>
        <p class="phone">{{ user.phone }} <span v-if="user.inviterCode">邀请码：{{ user.inviterCode }} <span class="copy"
              @click="copyInviteCode(user.inviterCode)">复制</span> </span></p>
        <div class="invite-code" @click="$router.push('/inviteCode')">
          <i class="iconfont icon-erweima" style="font-size: 30px;"></i>
        </div>
      </div>
    </div>
    <div class="info-list">
      <div class="info-item" @click="goToExchange">
        <div class="item-title">
          <van-icon name="info-o" />
          <span>我的兑换</span>
        </div>
        <van-icon name="arrow" />
      </div>
      <div class="info-item" @click="goToApply">
        <div class="item-title">
          <van-icon name="info-o" />
          <span>我的申请</span>
        </div>
        <van-icon name="arrow" />
      </div>
      <div class="info-item" @click="goToCompanyIntro">
        <div class="item-title">
          <van-icon name="info-o" />
          <span>公司介绍</span>
        </div>
        <van-icon name="arrow" />
      </div>
      <div class="info-item" @click="goToUserAgreement">
        <div class="item-title">
          <van-icon name="info-o" />
          <span>用户协议</span>
        </div>
        <van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/api/index'
export default {
  data() {
    return {
      user: {

      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      getUserInfo().then((res) => {
        console.log(res);
        this.user = res;
        localStorage.setItem('user', JSON.stringify(res));
      })
    },
    goToExchange() {
      this.$router.push('/exchange'); // 跳转到我的兑换页面
    },
    goToApply() {
      this.$router.push('/tryOut'); // 跳转到我的申请页面
    },
    goToCompanyIntro() {
      this.$router.push('/introduce'); // 跳转到公司介绍页面
    },
    goToUserAgreement() {
      this.$router.push('/agreement'); // 跳转到用户协议页面
    },
    copyInviteCode(text) {
      if (!text) return;
      const input = document.createElement('input');
      input.setAttribute('readonly', 'readonly');
      input.value = text;
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);

      input.select();
      input.setSelectionRange(0, input.value.length);
      try {
        document.execCommand('copy');
      } catch (e) {
        console.warn('复制失败', e);
      }

      document.body.removeChild(input);
    }

  },
};
</script>

<style scoped>
.user-info {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.header {
  margin-bottom: 20px;
  display: flex;
  position: relative;

  .info {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.invite-code {
  position: absolute;
  right: 5%;
  top: 0;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.name {
  font-size: 24px;
  font-weight: bold;
}

.gold {
  color: gold;
  font-size: 16px;
  margin: 10px 0;
}

.phone {
  color: #666;
}

.copy {
  color: #0F40F5;
  margin-left: 10px;
  cursor: pointer;
}

.info-list {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  cursor: pointer;
  margin-bottom: 10px;
}

.item-title {
  display: flex;
  align-items: center;

  span {
    margin-left: 10px;
  }
}

.info-item:last-child {
  border-bottom: none;
}

.info-item:hover {
  background-color: #f0f0f0;
}

.exchange {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  margin-left: 20px;
  border-radius: 5px;
  background: gold;
  color: #fff;
}
</style>